module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-3 mask",
    on: {
      "click": _vm.activateFn
    }
  }, [_c('input-text', _vm._b({
    class: [
      'input-button',
      _vm.activate ? 'active-input' : null
    ],
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, 'input-text', _vm.$attrs, false))], 1), _vm._v(" "), (_vm.activate) ? _c('input-text', {
    attrs: {
      "readonly": _vm.blockButton,
      "value": _vm.value
    },
    on: {
      "input": _vm.sendValue
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a5e145f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/ButtonField.vue
// module id = 1222
// module chunks = 1 23